export default {
  RESOURCE_EXISTS: 'User already created.',
  INVALID_CREDENTIALS: 'Username/Password incorrect',
};
